/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { CountAdjIndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const countAdjIndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const countAdjIndexFetchCountAdjIndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const countAdjIndexFetchCountAdjIndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const countAdjIndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const countAdjIndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const countAdjIndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const countAdjIndexWorkspaceLoading = (state, { boolean }) => ({
  ...state,
  workspaceIsLoading: boolean
});

export const countAdjIndexResetCountAdjSync01Success = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

export const countAdjIndexResetCountAdjFServ01Success = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [CountAdjIndexTypes.COUNT_ADJ_INDEX_RESET_TIMESTAMP]: countAdjIndexResetTimestamp,
  [CountAdjIndexTypes.COUNT_ADJ_INDEX_FETCH_COUNT_ADJ_INDEX_LOADING]: countAdjIndexFetchCountAdjIndexLoading,
  [CountAdjIndexTypes.COUNT_ADJ_INDEX_FETCH_COUNT_ADJ_INDEX_SUCCESS]: countAdjIndexFetchCountAdjIndexSuccess,
  [CountAdjIndexTypes.COUNT_ADJ_INDEX_ADD_SELECTED_DOCUMENTS]: countAdjIndexAddSelectedDocuments,
  [CountAdjIndexTypes.COUNT_ADJ_INDEX_REMOVE_SELECTED_DOCUMENTS]: countAdjIndexRemoveSelectedDocuments,
  [CountAdjIndexTypes.COUNT_ADJ_INDEX_SET_WORKSPACE_VISIBLE]: countAdjIndexSetWorkspaceVisible,
  [CountAdjIndexTypes.COUNT_ADJ_INDEX_WORKSPACE_LOADING]: countAdjIndexWorkspaceLoading,
  [CountAdjIndexTypes.COUNT_ADJ_INDEX_RESET_COUNT_ADJ_SYNC01_SUCCESS]: countAdjIndexResetCountAdjSync01Success,
  [CountAdjIndexTypes.COUNT_ADJ_INDEX_RESET_COUNT_ADJ_F_SERV01_SUCCESS]: countAdjIndexResetCountAdjFServ01Success
});
